import { ReactNode } from 'react';

import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const commitMessageWrapperStyles = xcss({
  width: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontWeight: token('font.weight.regular'),
  paddingBlock: 'space.025',
});

const buildInformationWrapper = xcss({
  color: 'color.text',
  display: 'flex',
  alignItems: 'center',
  gap: 'space.075',
  paddingInlineEnd: 'space.500',
});

type Props = {
  children: ReactNode;
};

export const CommitMessageWrapper = ({ children }: Props) => (
  <Box xcss={commitMessageWrapperStyles}>{children}</Box>
);

export const BuildInformationWrapper = ({ children }: Props) => (
  <Box xcss={buildInformationWrapper}>{children}</Box>
);

export const BuildInformationWrappper = BuildInformationWrapper;
